/* "What exists" — the approaches to a problem, each with when to use it and
   what it costs. A comparison table that reads as a list on a phone. */
import { useTranslation } from 'react-i18next';
import { Source } from '../Source';
import type { Block } from '../../types';

export function OptionsBlock({ block }: { block: Block }) {
  const { t } = useTranslation();
  const opts = block.opts;
  if (!opts) return null;

  return (
    <figure className="fig" data-od-id="what-exists">
      <div className="fig-head">
        <span className="gauge">
          {opts.list.length} {t('optW')}
        </span>
        <span className="rule" />
      </div>
      <div className="fig-body">
        <div className="optlist">
          {opts.list.map((row, i) => (
            <div key={row.slug} className="optrow" data-od-id={`option-${row.slug}`}>
              <div>
                <span className="opt-name num">{('0' + (i + 1)).slice(-2)}</span>
                <span className="opt-title">{t(row.nKey)}</span>
                <p className="opt-what">{t(row.wKey)}</p>
              </div>
              <div className="opt-meta">
                <div className="concept">
                  <span className="k">{t('optUse')}</span>
                  <span className="v">{t(row.uKey)}</span>
                </div>
                <div className="concept">
                  <span className="k">{t('optCost')}</span>
                  <span className="v">{t(row.cKey)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {opts.ref && (
        <figcaption className="fig-foot">
          <Source refKey={opts.ref} />
        </figcaption>
      )}
    </figure>
  );
}
